import { DistrictLevelOfService } from 'graphql/hooks.generated'

export const districtLevelOfServiceDescriptions = {
  [DistrictLevelOfService.Platform]: 'Platform',
  [DistrictLevelOfService.PlatformProviders]: 'Platform + Providers',
  [DistrictLevelOfService.Providers]: 'Providers'
}
